import React from 'react';

//Hooks
import {useState, useEffect} from 'react';

//Components
import ServiceOptions from "../ServiceOptions/ServiceOptions";
import {ChevronRight} from "react-feather";

//Styles
import Styles from './ServiceCategory.module.scss';

const ServiceCategory = ({name, services, expanded, onExpandChanged}) => {
    const [isExpanded, setExpanded] = useState(false);
    const [expandedOptions, setExpandedOptions] = useState(null);

    useEffect(() => {
        setExpanded(expanded);
    }, [expanded]);

    if (name === 'Other') {
        return (
            <div className={Styles.otherContainer}>
                {services.map(service => (
                    <ServiceOptions
                        key={`service-${name}-${service.id}`}
                        service={service}
                        expanded={expandedOptions === service.name}
                        onExpandChanged={expanded => setExpandedOptions(expanded ? service.name : null)}
                    />
                ))}
            </div>
        );
    }

    return (
        <div className={Styles.container}>
            <button data-testid={`data-test-category-button-${name}`} className={[
                Styles.button,
                isExpanded && Styles.expanded
            ].join(' ')} onClick={() => {
                onExpandChanged(!isExpanded);
                setExpanded(!isExpanded);
            }}>
                <span className={Styles.name}>{name}</span>

                <ChevronRight className={Styles.chevron}/>
            </button>

            <div className={[
                Styles.services,
                isExpanded && Styles.expanded
            ].join(' ')}>
                {services.map(service => (
                    <ServiceOptions
                        key={`service-${name}-${service.id}`}
                        service={service}
                        expanded={expandedOptions === service.name}
                        onExpandChanged={expanded => setExpandedOptions(expanded ? service.name : null)}
                    />
                ))}
            </div>
        </div>
    )
};

export default ServiceCategory

